import { render, staticRenderFns } from "./recommend_product.vue?vue&type=template&id=20306c3c&scoped=true"
import script from "./recommend_product.vue?vue&type=script&lang=js"
export * from "./recommend_product.vue?vue&type=script&lang=js"
import style0 from "./recommend_product.vue?vue&type=style&index=0&id=20306c3c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20306c3c",
  null
  
)

export default component.exports